import type { Language } from '@packages/config';
import config from '@packages/config';
import { useIntl } from 'react-intl';

export const getUspDataEndpoint = (locale: string) =>
  config.staticContent.apiEndpoints.bucket
    .replace('<subfolder>', '/menus')
    .replace(
      '<locale>',
      config.i18n.languages.includes(locale.substring(0, 2) as Language)
        ? locale.substring(0, 2)
        : config.i18n.defaultLocale.substring(0, 2),
    )
    .replace('<identifier>', 'bucket-usp-bar');

export const useUspCacheKey = () => {
  const { locale } = useIntl();
  return `usp-data-${config.clientId}-${locale}`;
};
